import React, { useState, useEffect } from 'react';
import { useForm,useFieldArray,Controller} from 'react-hook-form';
import Select from "react-select";
import { useParams} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import dayjs from 'dayjs'
import 'dayjs/locale/it'
import activityService from '../../services/ActivityService';

dayjs.locale('it')

const defaultActivities = [
    {groups: {title:"Consegna",id: 13}}
];

export default function Activity({contract,refreshKey}) {
    const { id } = useParams();
    const {control,handleSubmit,reset,setValue,setError,clearErrors,formState: { errors }} = useForm();
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'activities',
    });
    const [groupsData, setGroupsData] = useState([]);
    const [message, setMessage] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const validateActivities = (activities) => {
        for (let i = 0; i < activities.length; i++) {
            const { startDate, endDate } = activities[i];
            if (!startDate) {
                setError(`activities.${i}.endDate`, {
                  type: 'manual',
                  message: `Data inizio obbligatoria`,
                });
                return false;
            }
            if (endDate && new Date(endDate) <= new Date(startDate)) {
                setError(`activities.${i}.endDate`, {
                  type: 'manual',
                  message: `Data fine non valida`,
                });
                return false;
            }
        }
        return true;
    };
    const saveOnlyActivities = async (data) => {
        const validation = validateActivities(data.activities);
        if (validation !== true) {
            return;
        }
        clearErrors();
        const activitiesNormalized = data.activities.map(p => ({
            id: p.id,
            title:p.title,
            startDate: dayjs(p.startDate).format('YYYY-MM-DDTHH:mm:ss'),
            endDate: p.endDate
              ? dayjs(p.endDate).format('YYYY-MM-DDTHH:mm:ss')
              : dayjs(p.startDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
            referenceId: id,
            groupId:p.groups?.id,
            type:'Contract',
            notes:p.notes
        }));
        activityService.updateActivities(id,activitiesNormalized)
            .then((res) => {
                const groupsMap = Object.fromEntries(
                    groupsData.map(g => [g.id, g])
                );
                const upActivities = res.data.map(p => ({
                    ...p,
                    groups: groupsMap[p.groupId]
                }));
                setValue('activities', upActivities);
                setMessage("Attività aggiornate con successo!");
                setErrorMsg("");
            }).catch((error) => {
                console.error("Error update activities: ", error);
                setMessage("");
                setErrorMsg("Errore modifica attività. Riprova.");
            }
        );
    }

    const handleAddActivity = () => {
        fields.length === 0 ? append(defaultActivities) : append();
    }

    const toDate = (value) => {
        if (!value) return null;
        return value instanceof Date ? value : new Date(value);
    };

    const fetchData = async () => {
        try {
            const [activityRes, groupRes] = await Promise.all([
                activityService.getFilter(id, 'Contract'),
                activityService.getFilterGroupV2(['Operativo','Contratti','Noleggi','Vendite'],!contract.eventName,contract.id_type)
            ]);

            const resultsData = activityRes.data || [];
            const groups = groupRes.data || [];
            setGroupsData(groups);

            const groupsMap = Object.fromEntries(
                groups.map(g => [g.id, g])
            );
            const activities = resultsData.map(p => ({
                ...p,
                groups: groupsMap[p.groupId]
            }));
            reset({
                activities
            });

        } catch (error) {
            console.error('Error fetching data', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, [refreshKey]);

  	return (
        <>
            <div className="card card-action">
                <div className="card-header align-items-center">
                    <h5 className="card-action-title mb-0">Attività</h5>
                    <div className="card-action-element">
                        <button onClick={handleSubmit(saveOnlyActivities)} className="btn btn-primary btn-sm edit-address" type="button">
                            <i className="bx bx-refresh bx-xs me-1_5"></i>Aggiorna
                        </button>
                    </div>
                </div>
                <div className="card-body">
                    {errorMsg && <div className="mb-6 text-center alert alert-outline-danger">{errorMsg}</div>}
                    {message && <div className="mb-6 text-center alert alert-outline-success">{message}</div>}
                {fields.length === 0 ? (
                    <div className="row mb-6">
                        <div className="col-sm-12 col-md-6">
                            <div className="dataTables_info" role="status" aria-live="polite">
                                Non ci sono attività salvate.
                            </div>
                        </div>
                    </div>
                ) : (
                    fields.map((item, index) => (
                        <div className="repeater-wrapper pt-0"  key={item.id}>
                            <div className="d-flex border rounded">
                                <div className="row w-100 p-4 g-6">
                                    <div className="col-4">
                                        <label className="form-label">Tipologia*</label>
                                        <Controller
                                            name={`activities.${index}.groups`}
                                            rules={{ required: 'Seleziona una tiplogia' }}
                                            control={control}
                                            render={({ field }) => (
                                                <Select
                                                  {...field}
                                                  className={errors?.activities?.[index]?.groups ? 'is-invalid' : ''}
                                                  classNamePrefix='filter'
                                                  options={groupsData}
                                                  getOptionLabel={(e) => e.title}
                                                  getOptionValue={(e) => e.id}
                                                />
                                            )}
                                        />
                                        {errors?.activities?.[index]?.groups && (
                                          <div className="invalid-input">
                                            {errors.activities[index].groups.message}
                                          </div>
                                        )}
                                    </div>
                                    <div className="col-3">
                                        <label className="form-label">Inizio</label>
                                        <Controller
                                            name={`activities.${index}.startDate`}
                                            control={control}
                                            rules={{ required: 'Data obbligatoria' }}
                                            render={({ field, fieldState }) => (
                                                <div>
                                                    <DatePicker
                                                        locale={it}
                                                        placeholderText="gg/mm/aaaa --:--"
                                                        selected={toDate(field.value)}
                                                        onChange={field.onChange}
                                                        timeIntervals={30}
                                                        showTimeSelect
                                                        dateFormat="dd/MM/yyyy HH:mm"
                                                        className={`form-control ${errors?.activities?.[index]?.startDate ? "is-invalid" : ""}`}
                                                    />
                                                </div>
                                            )}
                                        />
                                        {errors?.activities?.[index]?.startDate && (
                                          <div className="invalid-input">{errors.activities[index].startDate.message}</div>
                                        )}
                                    </div>
                                    <div className="col-3">
                                        <label className="form-label">Fine</label>
                                        <Controller
                                            name={`activities.${index}.endDate`}
                                            control={control}
                                            render={({ field, fieldState }) => (
                                                <div>
                                                    <DatePicker
                                                        locale={it}
                                                        placeholderText="gg/mm/aaaa --:--"
                                                        selected={toDate(field.value)}
                                                        onChange={field.onChange}
                                                        timeIntervals={30}
                                                        showTimeSelect
                                                        dateFormat="dd/MM/yyyy HH:mm"
                                                        className={`form-control ${errors?.activities?.[index]?.endDate ? "is-invalid" : ""}`}
                                                    />
                                                </div>
                                            )}
                                        />
                                        {errors?.activities?.[index]?.endDate && (
                                          <div className="invalid-input">{errors.activities[index].endDate.message}</div>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex flex-column align-items-center justify-content-between border-start p-2">
                                    <i className="bx bxs-circle bx-xs cursor-pointer"></i>
                                    <i className="bx bx-expand-alt cursor-pointer"></i>
                                </div>
                            </div>
                        </div>
                    ))
                )}
                    <div className="row">
                        <div className="col">
                            <button type="button" className="btn btn-sm btn-label-primary" onClick={() => handleAddActivity()}>
                                <i className="bx bx-plus bx-xs me-1_5"></i>
                                Aggiungi
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
	);
}